import { getUserData } from '../Utils'

const useAuth = () => {
  const userData = getUserData()
  const isVisitor =
    !userData || userData.email === 'seuemaildecontanto@email.com'
  const blacklist = userData?.permissions?.blacklist || []

  const can = (permission) => {
    return !blacklist.includes(permission)
  }

  return {
    isVisitor,
    userData,
    can,
    record_id: userData?.airtableData?.record_id
  }
}

export default useAuth
